import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "selector-search-header" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = {
  key: 3,
  class: "selector-search-header__search-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.theModel !== undefined)
      ? (_openBlock(), _createBlock(_component_q_input, {
          key: 0,
          outlined: "",
          dense: "",
          ref: "header_search_input",
          color: "white",
          class: "selector-search-header__input",
          modelValue: _ctx.theModel,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.theModel) = $event)),
          "hide-bottom-space": "",
          placeholder: _ctx.showFreeInput ? _ctx.$t('search_or_new') : _ctx.$t('search_label'),
          debounce: "300",
          clearable: !_ctx.useOwnClearButton,
          "clear-icon": _ctx.clearIconName,
          onClear: _cache[5] || (_cache[5] = ($event: any) => (_ctx.theModel = '')),
          onKeydown: [
            _withKeys(_withModifiers(_ctx.emitArrowDown, ["exact","prevent"]), ["down"]),
            _withKeys(_withModifiers(_ctx.emitArrowUp, ["exact","prevent"]), ["up"])
          ],
          onKeyup: _withKeys(_withModifiers(_ctx.emitEnter, ["stop","prevent"]), ["enter"])
        }, {
          append: _withCtx(() => [
            (_ctx.useOwnClearButton && _ctx.theModel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "selector-search-header__icon-btn",
                  "aria-label": _ctx.$t('clear_field'),
                  onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.theModel = ''), ["stop"]))
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "selector-search-header__icon selector-search-header__icon--clear" }, null, -1)),
                  _createVNode(_component_q_tooltip, {
                    delay: 300,
                    anchor: "top middle",
                    self: "center middle",
                    class: "aux-sel-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("clear_field")), 1)
                    ]),
                    _: 1
                  })
                ], 40, _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.showFreeInput && _ctx.theModel !== undefined && _ctx.freeInputTooltip)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "selector-search-header__icon-btn",
                  "aria-label": _ctx.freeInputTooltip,
                  onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitFreeInput && _ctx.emitFreeInput(...args)), ["stop"]))
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    class: "selector-search-header__icon-svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M8 3.33333V12.6667",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M3.33333 8H12.6667",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)),
                  _createVNode(_component_q_tooltip, {
                    delay: 300,
                    anchor: "top middle",
                    self: "center middle",
                    class: "aux-sel-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.freeInputTooltip), 1)
                    ]),
                    _: 1
                  })
                ], 40, _hoisted_3))
              : (_ctx.showFreeInput && _ctx.theModel !== undefined)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 2,
                    onClick: _withModifiers(_ctx.emitFreeInput, ["stop","prevent"]),
                    dense: "",
                    flat: "",
                    color: "accent",
                    size: "md",
                    icon: "add",
                    class: "q-pa-none"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
            (!_ctx.hideSearchIcon)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[9] || (_cache[9] = [
                  _createElementVNode("path", {
                    d: "M13.9998 13.9998L11.1064 11.1064",
                    stroke: "#999999",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1),
                  _createElementVNode("path", {
                    d: "M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z",
                    stroke: "#999999",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "clearable", "clear-icon", "onKeydown", "onKeyup"]))
      : _createCommentVNode("", true),
    (_ctx.showCloseButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "selector-search-header__close",
          "aria-label": _ctx.$t('close_selector'),
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.emitClose && _ctx.emitClose(...args)))
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M15 5L5 15",
              stroke: "#979797",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M5 5L15 15",
              stroke: "#979797",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]), 8, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}